<template>
  <el-dialog
    title="Invite guests"
    :visible.sync="visible"
    width="80%"
    :close-on-click-modal="false"
  >
    <el-container v-loading="preparingRequests">
      <el-main>
        <p class="text-muted">
          We are going to send message with activation link to all investors
          that have not been invited yet.
        </p>
        <p class="text-muted">Number of invites: {{ total }}</p>
        <el-checkbox v-model="notInvitedYetOnly">
          Send email to not invited yet only
        </el-checkbox>

        <div v-show="inProgress">
          <el-progress
            :percentage="percentage"
            :status="percentage === 100 ? 'success' : undefined"
          />
          <p class="text-muted">Progress: {{ progress }} / {{ total }}</p>
        </div>
      </el-main>
    </el-container>

    <el-footer>
      <div class="dialog-footer">
        <el-button
          :disabled="total === 0 || inProgress"
          type="primary"
          @click="submit()"
        >
          Send
        </el-button>
      </div>
    </el-footer>
  </el-dialog>
</template>

<script>
export default {
  props: {
    users: { type: Array, default: () => [] },
  },
  data() {
    return {
      visible: false,
      inProgress: false,
      progress: 0,
      preparingRequests: false,
      notInvitedYetOnly: true,
    }
  },
  computed: {
    usersToInvite() {
      if (this.notInvitedYetOnly) {
        return this.users.filter((user) => !user.invited_at)
      } else {
        return this.users
      }
    },

    emails() {
      return this.usersToInvite.map((user) => user.email)
    },

    total() {
      return this.usersToInvite.length
    },

    percentage() {
      if (this.total > 0) {
        const percentage = (this.progress / this.total) * 100
        return percentage | 0
      } else {
        return 0
      }
    },
  },
  methods: {
    open() {
      this.visible = true
      this.progress = 0
      this.inProgress = false
      this.preparingRequests = false
    },

    async submit() {
      this.inProgress = true
      this.preparingRequests = true
      setTimeout(async () => {
        await this.sendAllInvites()
        this.inProgress = false
        this.$emit('invited')
        this.visible = false
      }, 100)
    },

    async sendAllInvites() {
      const userIds = this.usersToInvite.map((user) => user.id)
      const allRequests = userIds.map((userId) => {
        const request = this.$store.dispatch('eventDetails/sendInvite', {
          userId,
        })
        request.then(() => {
          this.progress += 1
        })
        return request
      })
      await Promise.race(allRequests)
      this.preparingRequests = false
      return Promise.all(allRequests)
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  height: 100px;
}
</style>
